import { combineReducers } from "redux";
import { authReducer } from "./authReducer";
import { uiReducer } from "./uiReducer.js";
import { localesReducer } from "./localesReducer";
import { adsCampaignsReducer } from "./adsCampaignsReducer";
import { userReducer } from "./userReducer.js";
import { paymentsReducer } from "./paymentsReducer.js";
import { chatReducer } from "./chatReducer.js";
import { alertsReducer } from "./alertsReducer";
import { ownerReducer } from "./ownerReducer";
import { creativeTemplatesReducer } from "./creativeTemplatesReducer";
import { videoEditorReducer } from "./videoEditorReducer";

export const rootReducer = combineReducers({
  auth: authReducer,
  adsCampaigns: adsCampaignsReducer,
  chat: chatReducer,
  locales: localesReducer,
  ui: uiReducer,
  user: userReducer,
  payments: paymentsReducer,
  alerts: alertsReducer,
  owner: ownerReducer,
  creativeTemplates: creativeTemplatesReducer,
  videoEditor: videoEditorReducer,
});
